import { ACCOUNTANT_ROLE, MANAGER_ROLE } from '@Shared/constants/user_profile_constants';
import { IUserProfileModel } from '@Shared/models';

export function isManagerCheck(userProfile: IUserProfileModel) {
  return isManagerFlagCheck(userProfile) || userProfile.can_manager_approve;
}

export function isManagerFlagCheck(userProfile: IUserProfileModel) {
  return userProfile?.role === MANAGER_ROLE;
}

export function checkIsManager(managedUserProfile: IUserProfileModel, managerUserProfile: IUserProfileModel) {
  return managedUserProfile?.manager_user_profile_id === managerUserProfile.id;
}

export function isAdminCheck(userProfile: IUserProfileModel) {
  return userProfile.is_admin;
}

export function isAccountantCheck(userProfile: IUserProfileModel) {
  return userProfile.role === ACCOUNTANT_ROLE;
}

export function isAdminOrAccountantCheck(userProfile: IUserProfileModel) {
  return userProfile.is_admin || userProfile.role === ACCOUNTANT_ROLE;
}
